export const imgPath = (value) => {
  return `${process.env.REACT_APP_SERVER_URL}/files/${value}`;
};
